module.exports = __webpack_public_path__ + "img/180deg.4e3fdf91.svg";